export default {
  lead_modal: {
    title: '📩 Уточнить цену и наличие',
    subtitle:
      'Цена и статус объекта могут изменяться. Оставьте контакт — агент подтвердит актуальные условия.',

    name: 'Ваше имя',
    contact: 'WhatsApp номер',
    message: 'Сообщение (необязательно)',

    cancel: 'Отмена',
    submit: 'Отправить',
    sending: 'Отправка…',

    success: 'Запрос отправлен!',
    error_unknown: 'Неизвестная ошибка'
  }
}
